/**
 * Legacy website Remy / voice concierge kill switch.
 * Product voice lives on mobile; web stays off unless explicitly re-enabled.
 */
export function isWebRemyEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_WEB_REMY === 'true';
}
